import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { EditableUserProfile } from "src/components/user/EditableUserProfile"

export const UserProfile = () => {

    return (
        <PageLayout
            header={<PageHeader
                title="My Profile"
            />
        }>
            <EditableUserProfile />
        </PageLayout>
    )
}